// Зеркало portfolios/weights.py::resolve_weights (без свёртки стейблов):
// Портфель показывает ровно те доли, с которыми участник попадёт на страницу «Портфели».
export const WEIGHT_STATUS = {
  EQUAL: 'equal',
  REMAINDER: 'remainder',
  SCALED: 'scaled',
  EXACT: 'exact',
  OVER: 'over',
};

const EPSILON = 1e-9;

//Преобразовать ввод пользователя в число: пусто → null, мусор → NaN, запятая допустима
export function parseWeight(value) {
  if (value === null || value === undefined) return null;
  const text = String(value).trim().replace(',', '.');
  if (text === '') return null;
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return NaN;
  return Number(text);
}

//Корректна ли доля: пусто или число от 0 до 100
export function isValidWeight(value) {
  const weight = parseWeight(value);
  return weight === null || (!Number.isNaN(weight) && weight >= 0 && weight <= 100);
}

//Итоговые доли портфеля по правилам спеки (раздел 4.2)
export function resolveWeights(items) {
  const specified = items.filter((item) => item.weight !== null);
  const blank = items.filter((item) => item.weight === null);
  const total = specified.reduce((sum, item) => sum + item.weight, 0);
  const shares = {};

  if (!items.length) {
    return { shares, total: 0, blankCount: 0, status: WEIGHT_STATUS.EQUAL };
  }
  if (!specified.length || (total <= EPSILON && !blank.length)) {
    items.forEach((item) => { shares[item.key] = 100 / items.length; });
    return { shares, total, blankCount: blank.length, status: WEIGHT_STATUS.EQUAL };
  }

  let status;
  if (total > 100) {
    specified.forEach((item) => { shares[item.key] = (item.weight * 100) / total; });
    blank.forEach((item) => { shares[item.key] = 0; });
    status = WEIGHT_STATUS.OVER;
  } else if (blank.length) {
    const rest = (100 - total) / blank.length;
    specified.forEach((item) => { shares[item.key] = item.weight; });
    blank.forEach((item) => { shares[item.key] = rest; });
    status = WEIGHT_STATUS.REMAINDER;
  } else {
    specified.forEach((item) => { shares[item.key] = (item.weight * 100) / total; });
    status = Math.abs(total - 100) <= EPSILON ? WEIGHT_STATUS.EXACT : WEIGHT_STATUS.SCALED;
  }
  return { shares, total, blankCount: blank.length, status };
}

//Доля для отображения: «37,5»
export function formatShare(value) {
  return value.toLocaleString('ru-RU', { maximumFractionDigits: 1 });
}
